import AddEvent from './components/UserEvents/AddEvent';
import Navbar from "./components/Miscel/Navbar";
import Homepage from "./components/Homepage/Homepage";
import {BrowserRouter as Router, Route, Link, Routes} from 'react-router-dom';
import Login from "./components/UserEvents/Login";
import SingleAlumni from './components/SingleEvent/SingleAlumni';

import AddImages from './components/SingleEvent/Comps/AddImages';
import React from 'react'
import Dashboard from './components/Dashboard/Dashboard';
import UsersList from './components/Dashboard/UsersList/UsersList';
import EventsList from './components/Dashboard/EventsList/EventsList';
import { useState } from 'react';

function App() {

  const [reloadNavbar,setReloadNavbar] = useState();

  return (
    <>      
      <Navbar reloadNavbar={reloadNavbar}/>
        <Routes>            
          <Route path="/" element={<Homepage />} />
          <Route path="/login" exact element={<Login setReloadNavbar={setReloadNavbar}/>} />                      
          <Route path="/add" exact element={<AddEvent />} />             
          <Route path="dashboard" element={<Dashboard />}>
            <Route path="users" element={<UsersList/>} />
            <Route path="events" element={<EventsList/>} />
          </Route>
          <Route path="/update/:id" exact element={<AddImages />} />   
          <Route path="/event/:id" exact element={<SingleAlumni />}/>
        </Routes>
   </>
  );
}

export default App;
